export default {
  financialInvestmentSelection: {
    drawer: {
      sections: {
        generalDatas: {
          title: 'Données générales',
          productType: 'Type de produit',
          minimumSubscriptionAmount: 'Minimum de souscription'
        },
        taxationDatas: {
          title: 'Données fiscales',
          inGeneralCeiling: 'Compris dans le plafond général',
          inComplementaryCeiling: 'Compris dans le plafond complémentaire',
          taxReductionRate: 'Taux de la réduction (IR)',
          eligibleTaxReductionRate: "Taux d'investissement en actifs éligibles à la réduction",
          maxPaymentSolo: 'Plafonds de versement personne seule (IR)',
          maxPaymentCouple: 'Plafonds de versement couple (IR)',
          tauxRentaGestion: 'Taux de rentabilité du produit attribué par la société de gestion',
          tauxRetro: 'Taux max de rétrocession de l\'avantage fiscal'
        }
      },
      values: {
        yes: 'Oui',
        no: 'Non',
      }
    },
    card: {
      taxationFinancialProductSelectionLabel: 'Sélectionner',
      investmentSelectionSectionLabel: 'Veuillez sélectionner les investissements parmi ces dispositifs fiscaux :',
      lightTagLabel: 'À partir de {minimumSubscriptionAmount}',
    }
  },
  financialInvestmentAllocation: {
    estimatedTaxGain: 'Gain fiscal estimé',
    drawer: {
      title: 'Impact sur votre fiscalité',
      tagLabel: 'Gain Fiscal',
      taxationSectionTitle: 'Fiscalité',
      taxNichesSectionTitle: 'Niches Fiscales',
      fiscalImpactTitle: 'Impact fiscal',
      fiscalImpactSubtitle: "Projection de l'impact sur votre situation fiscale",
      SimulationIndicatorsCard: {
        remainingCap: 'Plafond épargne retraite disponible',
        remainingGeneral: 'Plafond général des niches fiscales restantes',
        remainingComplementary: 'Plafond complémentaire des niches fiscales restantes'
      }
    }
  },
  skipWithoutInvest: 'Passer sans investir',
  declineInvestment: 'Refuser ce conseil'
}
